<template>
  <div class="enterprise-list-page enterprise-list-page--people">    <!-- Header Card -->
        <PageHeader icon="fas fa-users">
      <template #title>
        Daftar Karyawan {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola data karyawan, jabatan, departemen, dan status kepegawaian klinik
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="manipulateBtn == true"
                @click="$router.push({ name: 'employee-add' })">
                <i class="fas fa-plus"></i>
                <span>Tambah Karyawan</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <div>
              <HrTable purpose="master"/>
            </div>
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import HrTable from '@/component/human-resource/Table.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: 'List',

  components: {
    Card,
    HrTable
  },
  data(){
    return{
      manipulateBtn:false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    }
  },

  methods:{
    // access management
    async setActiveMenu(){

     let access_right_user = window.localStorage.getItem("access_right_display")
     let access_right = JSON.parse(access_right_user)
    
    let a
    for(a = 0; a < access_right.length; a++){
      
      
      if(access_right[a] == "7002"){
        this.manipulateBtn = true
      }
      
    }
    },
  },
  
  mounted() {
    this.setActiveMenu()
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Karyawan" },
      { title: "Daftar Karyawan" },
    ])
    
  },

}
</script>

